import React,{ Component } from "react";
import {
  NavBar,
  WhiteSpace,
  WingBlank,
  Card,
  Icon,
  Toast,
  Button
} from "antd-mobile"
import axios from '../../../service/axios'
import './deviceInfo.scss'

export class DeviceInfo extends Component {
  state = {
    deviceInfo:{
      id: '',   // 设备id
      dmrName:'',  // 设备名称
      name:'',  // 账号名称
    },   // 设备数据初始化对象
    priority: [2],  // 组内优先级
    mode: 'dmr',  // 模式, 默认dmr模式
    defaultGid: "",
    TX_FREQ: 0,  // 发射频率,由用户输入
    RX_FREQ: 0,  // 接收频率,由用户输入
    DMRCfg:{
      DMR_CC: [0], // 色码，默认0
      TX_FREQ:'0', // 发射频率
      RX_FREQ:'0', // 接收频率
    },
    FMCfg:{
      RX_CTCSS_TYPE: [0],  //  接收亚音模式,默认无亚音
      RX_CTCSS_VAL: [0],  // 接收亚音的值
      TX_CTCSS_TYPE: [0],  //  发射亚音模式,默认无亚音
      TX_CTCSS_VAL: [0],  // 发射亚音的值
      FM_PWR: [0],  // 功率,默认低功率
      FM_WIDTH: [0],  // 宽窄带模式, 默认窄带
      TX_FREQ:'0', // 发射频率
      RX_FREQ:'0', // 接收频率
    }
    
  }
  componentWillMount() {
    this.getDeviceInfoById(this.props.location.search.split("?")[1])
  }

  // 获取设备详情信息
  getDeviceInfoById(deviceId){
    axios
      .post(
        '/api/dmrgw/wechat/detail',{id:deviceId}
      ).then((res)=>{
        console.log(res,"axios")
        if (res && res.status === 200){
          this.setState({
            deviceInfo: res.data
          })
          this.getConfigInfo(res.data.dmrCfg,res.data.digitCfg)
        }else{
          Toast.fail(res.message)
        }
      })
  }

  // 解析Config字段
  getConfigInfo(dmrCfg,digitCfg){
    if( dmrCfg && digitCfg ){
      // 解析dmr配置
      console.log(dmrCfg,'解析dmr?')
      let DMR_Cfg_Arr = dmrCfg.split(";")
      let DMR_Obj = {} 
      DMR_Cfg_Arr.map((item) => {
          let str = item.split(":")
          str[1] = str[0] === 'DMR_CC'?str[1]=[Number(str[1])]:str[1]
          DMR_Obj[str[0]] = str[1]
        })
      console.log(DMR_Obj,'DMR_Obj?')
      this.setState({DMRCfg:DMR_Obj})
      
      // 解析digit配置
      console.log(digitCfg,'解析digit?')
      let FM_Cfg_Arr = digitCfg.split(";")
      let FM_Obj = {} 
      FM_Cfg_Arr.map((item) => {
          let str = item.split(":")
          str[1] = str[0] === 'RX_CTCSS_TYPE'?str[1]=[Number(str[1])]:str[1]
          str[1] = str[0] === 'TX_CTCSS_TYPE'?str[1]=[Number(str[1])]:str[1]
          str[1] = str[0] === 'RX_CTCSS_VAL'?str[1]=[Number(str[1])]:str[1]
          str[1] = str[0] === 'TX_CTCSS_VAL'?str[1]=[Number(str[1])]:str[1]
          str[1] = str[0] === 'FM_PWR'?str[1]=[Number(str[1])]:str[1]
          str[1] = str[0] === 'FM_WIDTH'?str[1]=[Number(str[1])]:str[1]
          FM_Obj [str[0]] = str[1]
        })
      console.log(FM_Obj,'FM_Obj?')
      this.setState({FMCfg:FM_Obj})
    }
  }
  render(){
    const {deviceInfo,DMRCfg,FMCfg} = this.state
    const {DMR_CC} = DMRCfg
    const {
      TX_CTCSS_TYPE,
      TX_CTCSS_VAL,
      RX_CTCSS_TYPE,
      RX_CTCSS_VAL,
      FM_PWR,
      FM_WIDTH
    } = FMCfg
    return (
      <div className="deviceInfo">
        <div className="header-sticky">
          <NavBar
            icon={<Icon type="left" />}
            onLeftClick={() => this.props.history.goBack()}
          >
            设备详情
          </NavBar>
        </div>
        <div className="device-content">
          <Card full="true">
            <Card.Header title="基础信息"/>
            <Card.Body>
              <div>设备名称:<span>{deviceInfo.dmrName}</span></div>
              <div>IMEI:<span>{deviceInfo.dmrImei}</span></div>
              <div>所属管理员:<span>{deviceInfo.loginName}</span></div>
              <div>默认群组:<span>{deviceInfo.defaultGidName}</span></div>
              <div>讲话优先级:<span>{deviceInfo.priority ===0?"账号优先":deviceInfo.priority ===1?"设备优先":"优先级相同"}</span></div> 
              <div>状态:<span>{deviceInfo.status === 0?<span style={{color:"red"}}>未启用</span>:<span style={{color:"green"}}>已启用</span>}</span></div>
              <div>当前模式:<span>{deviceInfo.mode ==="dmr" && !deviceInfo.mode?"DMR模式":"模拟模式"}</span></div>
            </Card.Body>
          </Card>
          <WhiteSpace size="xl"/>
          <Card full="true">
            <Card.Header title = "dmr参数"/>
            <Card.Body>
              <div>发射频率:<span>{DMRCfg.TX_FREQ === 'undefined'?'未设置':DMRCfg.TX_FREQ + 'MHz'}</span></div>
              <div>接收频率:<span>{DMRCfg.RX_FREQ === 'undefined'?'未设置':DMRCfg.RX_FREQ + 'MHz'}</span></div>
              <div>色码:<span>{'色码'+DMR_CC}</span></div>
            </Card.Body>
          </Card>
          <WhiteSpace size="xl"/>
          <Card full="true">
            <Card.Header title="模拟参数"/>
            <Card.Body>
              <div>发射频率:<span>{FMCfg.TX_FREQ === 'undefined'?'未设置':FMCfg.TX_FREQ + 'MHz'}</span></div>
              <div>接收频率:<span>{FMCfg.RX_FREQ === 'undefined'?'未设置':FMCfg.RX_FREQ + 'MHz'}</span></div>
              <div>发射亚音模式:<span>{TX_CTCSS_TYPE[0] === 0 ? "无亚音" : TX_CTCSS_TYPE[0] === 1 ? "模拟亚音": TX_CTCSS_TYPE[0] === 2 ? "数字亚音N" : TX_CTCSS_TYPE[0] === 3 ? "数字亚音I" : "无"}</span></div>
              <div>发射亚音频率:<span>{TX_CTCSS_VAL}</span></div>
              <div>接收亚音模式:<span>{RX_CTCSS_TYPE[0] === 0 ? "无亚音" : RX_CTCSS_TYPE[0] === 1 ? "模拟亚音": RX_CTCSS_TYPE[0] === 2 ? "数字亚音N" : RX_CTCSS_TYPE[0] === 3 ? "数字亚音I" : "无"}</span></div>
              <div>接收亚音频率:<span>{RX_CTCSS_VAL}</span></div>
              <div>功率模式:<span>{FM_PWR[0] === 0 ? "低功率" : FM_PWR[0] === 1?"高功率":"无"}</span></div>
              <div>模拟宽/窄带:<span>{FM_WIDTH[0] === 0?"窄带":FM_WIDTH[0] === 1?"宽带":"无"}</span></div>
            </Card.Body>
          </Card>
        </div>
        <WingBlank>
          <WhiteSpace size="xl" />
          <Button type="primary" onClick={() => this.props.history.push('/setDeviceInfo?'+ this.state.deviceInfo.id)}>
            设置
          </Button>
          <WhiteSpace size="xl" />
          <Button type="" onClick={() => window.history.go(-1)}>
            返回
          </Button>
          <WhiteSpace size="xl" />
        </WingBlank>
      </div>
    )
  }
}

export default DeviceInfo